import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TransactionRowBaseComponent } from '../transaction-row-base.component';
@Component({
  selector: 'app-transaction-row-touch',
  templateUrl: './transaction-row-touch.component.html',
  styleUrls: ['./transaction-row-touch.component.scss'],
})
export class TransactionRowTouchComponent extends TransactionRowBaseComponent {
  @Input() isMobile: boolean;

  constructor(private translate: TranslateService) {
    super();
  }

  private columnBase(customerPO: string, orderNumber: string) {
    const orderNumberField = this.showOrderNumber
      ? [
          {
            text: this.translate.instant(
              'i18n.payments.transactionRow.orderNumber',
            ),
            value: orderNumber,
          },
        ]
      : [];

    return [
      ...orderNumberField,
      {
        text: this.translatorText.custPo,
        value: customerPO,
      },
    ];
  }

  private firstColumn(
    amountDue: string,
    customerPO: string,
    amount: string,
    orderNumber: string,
  ) {
    const columnBase = this.columnBase(customerPO, orderNumber);
    if (this.isCredit) {
      return columnBase;
    }

    return [
      {
        text: this.translatorText.dueDateCut + ': ',
        value: amountDue,
      },
      {
        text: this.translatorText.amount + ':',
        value: amount,
      },
      ...(this.isMobile ? columnBase : []),
    ];
  }

  private secondColumn(
    issueDate: string,
    amount: string,
    paymentAmount: string,
    customerPO: string,
    orderNumber: string,
  ) {
    if (this.isCredit) {
      return [
        {
          text: this.translatorText.amount + ':',
          value: amount,
        },
        {
          text: this.translatorText.issueDateCut + ':',
          value: issueDate,
        },
      ];
    }
    if (this.isMobile) {
      return [
        {
          text: this.translatorText.issueDateCut + ':',
          value: issueDate,
        },
        {
          text:
            this.translate.instant('i18n.payments.transactionRow.payment') +
            ':',
          value: paymentAmount,
        },
      ];
    }

    return this.columnBase(customerPO, orderNumber);
  }

  private thirdColumn(issueDate: string, paymentAmount: string) {
    if (this.isMobile || this.isCredit) {
      return [];
    }

    return [
      {
        text: this.translatorText.issueDateCut + ':',
        value: issueDate,
      },
      {
        text:
          this.translate.instant('i18n.payments.transactionRow.payment') + ':',
        value: paymentAmount,
      },
    ];
  }

  getColumns(
    amountDue: string,
    customerPO: string,
    amount: string,
    orderNumber: string,
    issueDate: string,
    paymentAmount: string,
  ) {
    return [
      this.firstColumn(amountDue, customerPO, amount, orderNumber),
      this.secondColumn(
        issueDate,
        amount,
        paymentAmount,
        customerPO,
        orderNumber,
      ),
      this.thirdColumn(issueDate, paymentAmount),
    ];
  }
}
